import * as IOGateway from './main.js';

export {IOGateway};

IOGateway.Factory['create'] = IOGateway.Factory;
IOGateway.Factory['configure_logging'] = IOGateway.Logging.configure;

export default IOGateway.Factory;
